<template>
  <div>
    <van-nav-bar
      title="绑定银行卡"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="realName"
        name="bankName"
        label="开户人姓名"
        placeholder="开户人姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="bankCard"
        type="digit"
        name="bankCard"
        label="银行卡卡号"
        placeholder="银行卡卡号"
        :rules="[{ required: true, message: '请填写银行卡卡号' }]"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="bank"
        label="开户行全称"
        placeholder="点击选择开户行全称"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择开户行' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="bankList"
          @confirm="onConfirm"
          value-key="bank"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="bankSite"
        name="bankName"
        label="开户行地址"
        placeholder="开户行地址"
        :rules="[{ required: true, message: '请填写开户行地址' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="danger" size="small" native-type="submit">
          确定
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "BindBank",
  data() {
    return {
      showPicker: false,
      realName: "",
      bankCard: "",
      bankId: "",
      bank: "",
      bankList: [],
      bankSite: "",
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    onSubmit() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "bind_bank",
            token: sessionStorage.getItem("token"),
            name: that.realName,
            bank_id: that.bankId,
            address: that.bankSite,
            card: that.bankCard,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
              onClose: function () {
                that.$router.push({
                  path: "/member/information",
                });
              },
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onConfirm(value) {
      this.bank = value.bank;
      this.bankId = value.id;
      this.showPicker = false;
    },
    getBankList() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "bank_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            that.bankList = res.data.data.bank;
            that.bankCard = resData.data.card;
            that.realName = resData.data.account;
            that.bankSite = resData.data.address;
            that.bank = resData.data.name;
            that.bankId = resData.data.id;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getBankList();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BindBank.vue